import api from "./webapp";

export default class AuthApi {
  static async login(email: string, password: string) {
    try {
      const { data } = await api.post("/autenticarSenha", { usuario: email, senha: password });
      if (!data || !data.loginValido) return null;
      return data;
    } catch (_) {
      return null;
    }
  }

  static async generateSessionToken(sessionId: string, companyCode: string, userId: string): Promise<string | null> {
    try {
      const { data } = await api.post("/generate-session-token", { sessionId, companyCode, userId });
      if (!data || !data.sharedToken) return null;
      return data.sharedToken;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}
